<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">基本コミッション検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="load"
          class="btn-search"
          v-permit.SHARP_BC_SEARCH
        >{{$t('app.buttons.search')}}</v-btn>
        <v-btn to="/m0211/new" v-permit.SHARP_BC_NEW>{{$t('app.buttons.new')}}</v-btn>
        <v-btn
          :disabled="selected.length!==1"
          @click="edit"
          v-permit.SHARP_BC_EDIT.SHARP_BC_DETAIL
        >{{$t('app.buttons.edit')}}</v-btn>
        <v-btn
          :disabled="selected.length===0"
          @click="remove"
          v-permit.SHARP_BC_DELETE
        >{{$t('app.buttons.remove')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete label="適用海外取引先" url="companies/kv" v-model="query.partnerName"/>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <v-text-field clearable label="ｺﾐｯｼｮﾝレート From" v-model="query.rateFrom"></v-text-field>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <v-text-field clearable label="ｺﾐｯｼｮﾝレート To" v-model="query.rateTo"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <date-picker label="適用開始日" v-model="query.startDate"/>
            </v-flex>

            <v-flex md3 sm6 xs6>
              <date-picker :min="query.startDate" label="適用終了日" v-model="query.endDate"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <!-- <td>{{ props.item.consumptionTaxName }}</td> -->
          <td>{{ props.item.rate }}</td>
          <td>{{ props.item.startDate }}</td>
          <td>{{ props.item.endDate }}</td>
          <td>{{ props.item.partnerName ||'全体' }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { text: 'ｺﾐｯｼｮﾝレート', value: 'rate', sortable: false },
        { text: '適用開始日', value: 'startDate', sortable: false },
        { text: '適用終了日', value: 'endDate', sortable: false },
        { text: '適用サプライヤー', value: 'partner.name', sortable: false }
      ],
      pagination: {
        page: 1
      },
      query: {},
      selected: [],
      loading: false,
      results: []
    }
  },
  methods: {
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http
        .get('commission-rates', {
          params: { ...this.query, ...this.$pageable() }
        })
        .then(res => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    edit() {
      this.$router.push({
        name: 'EditM0211',
        query: { id: this.selected[0].id }
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(s => {
              return this.$http.delete(`/commission-rates/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
          })
        }
      )
    }
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    }
  }
}
</script>
